// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"840":"c94196ea6f8ea305c3d6","855":"a67a2031face8c0c9cfa","888":"85d71e1d32889c628093"}[chunkId] + ".css";
};